import { Component, ElementRef, OnInit, ViewChild, inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { Permission, Permissions } from 'src/app/Constants/Admin/Permissions';
import { Icon_Image } from 'src/app/Constants/Constants-Global/Images-Icon';
import { Icon_Images } from 'src/app/Interfaces/Interfaces-Global/Icon_Images.interface';
import { Response_CCP } from 'src/app/Interfaces/Interfaces-Global/Response.interface';
import { Download_CPP } from 'src/app/Interfaces/Libraries/Library-CCP-Int/Download_ALL_Files.interface';
import { FILE_CAP } from 'src/app/Interfaces/Libraries/Library-FIN-int/FileCAP.interface';
import { Create_Template_CCP, Template_CCP } from 'src/app/Interfaces/Libraries/Library-CCP-Int/Template_CCP.interface';
import { UserDataService } from 'src/app/Services/Authentication/User/user-data.service';
import { PermisionsFolderService } from 'src/app/Services/Global/Permissions/permisions-folder.service';
import { LIBRARYCCPService } from 'src/app/Services/Libraries/General-CCP/library-ccp.service';
import { LibraryFINService } from 'src/app/Services/Libraries/General-FIN/library-fin.service';
import { GeneralRoleCDMS, typeSystemRoleCDMS } from 'src/app/types/General/RoleCDMS.type';
import Swal from 'sweetalert2';

@Component({
    selector: 'app-see-templates-in-ccp',
    templateUrl: './see-templates-in-ccp.component.html',
    styleUrls: ['./see-templates-in-ccp.component.scss', './../../../../../Styles/GlobalStyles.css'],
    standalone: false
})
export class SeeTemplatesInCCPComponent implements OnInit {


  @ViewChild('AddTemplate')
  MyInputAddTemplate!: ElementRef;

  //+================== VARIABLES BAND FOR UPDATE OR NEW LOAD ==================+\\
  public IsUpdate: boolean = false;

  //+================== VARIABLES GLOBAL FILES MANUAL ==================+\\
  public All_CCP_Templates: Template_CCP[] = [];

  //+================== VARIABLE ROLES GENERAL ==================+\\
  public RolesGeneral: typeSystemRoleCDMS = GeneralRoleCDMS;

  //+================== VARIABLES FOR LOAD PAGE ==================+\\
  public LoadPage: boolean = false;


  //+================== VARIABLES FILES ==================+\\
  public FileAuxAddTemplate: FILE_CAP = { FileData: null, FileName: '' };
  public Template_Selected: Template_CCP = {
    ID: 0,
    ID_Contributor: 0,
    Name: '',
    Extension: '',
    Status: 0,
    ID_Next_Version: 0,
    ID_Previous_Version: 0,
    Upload_Date: null,
  }

  //+================== VARIABLES FOR ICONS IMAGE ==================+\\
  public Icons_Image: Icon_Images[] = Icon_Image;


  //+================== VARIABLES FOR COLOR SWETALERT ==================+\\
  private ColorConfirm: string = '#20a8e1';
  private ColorsCancel: string = '#fc6161';


  // //-========================= SERVICES =========================-\\
  public UserService = inject(UserDataService);
  private Service_CCP = inject(LIBRARYCCPService);
  private Service_FIN = inject(LibraryFINService); // FOR DOWNLOAD FILES

  constructor() { }

  ngOnInit(): void {
    this.Load_Component();
  }
  //&===================== FUNCTIONS FOR LOAD COMPONENT =====================&\\

  //-================== FUNCTION FOR LOAD COMPONENT ==================-\\
  private async Load_Component(): Promise<void> {
    this.LoadPage = false;
    const Loader = document.getElementById('Loader') as HTMLDivElement;
    Loader.classList.add('active');

    try {

      await this.Load_All_Templates();

      Loader.classList.remove('active');
      this.LoadPage = true;
    } catch (e) {
      Swal.fire({
        title: 'Ocurrió un error (Plantillas)',
        text: '¡Recargue la página, si el problema persiste notifique a supervisor!',
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      }); Loader.classList.remove('active');
    }
  }

  //-================== FUNCTION FOR LOAD MANUALS ==================-\\
  private async Load_All_Templates(): Promise<boolean> {
    try {

      const Response_Template: Response_CCP = await firstValueFrom(this.Service_CCP.Get_Templates_CCP());

      if (Response_Template.success) {
        this.All_CCP_Templates = Response_Template.operation;
      }

      return true;
    } catch (e) {
      Swal.fire({
        title: 'Ocurrió un error (Templatees)',
        text: '¡Recargue la página, si el problema persiste notifique a supervisor!',
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      });
      return true;
    }
  }


  //&===================== END FUNCTIONS FOR LOAD COMPONENT =====================&\\




  //&===================== FUNCTIONS FOR GENERAL COMPONENT =====================&\\

  //-================== FUNCTTION RETURN CLASS FILE ==================-\\
  public Type_Extension_Class(Extension: string): string {
    return this.Icons_Image.find(item => item.Extension.toLowerCase() === Extension.toLowerCase())?.Class || 'not-found';
  }

  //-================== FUNCTTION FOR RETURN URL IMAGE ==================-\\
  public Type_Extension_Img(Extension: string): string {
    return this.Icons_Image.find(item => item.Extension.toLowerCase() === Extension.toLowerCase())?.Url_Image.toLowerCase() || 'not-found.png';
  }

  //-================== FUNCTTION FOR VERIFICATE IF UPDATE OR NEW MODAL ==================-\\
  public OpenModalIsUpdate(IsUpdate: boolean, Template: Template_CCP | null): void {
    this.IsUpdate = IsUpdate;
    if (Template !== null) this.Template_Selected = Template;

    this.ToggleModalAddTemplate(true);
  }

  //-================ FUNCTION FOR NAME USER ================-\\
  public NameUser(): string {
    const Name_User: string = localStorage.getItem('Name_User') || "";
    return (Name_User.split(' ', 2)).join(' ');
  }

  public Cut_Name(NameTemplate: string): string {

    let NameTemplate_List = NameTemplate.split('.');
    NameTemplate_List.pop();

    const Name_Clen: string = NameTemplate_List.join('.');

    return Name_Clen.length > 40 ? Name_Clen.slice(0, 40) + '...' : Name_Clen;

  }

  //&===================== END FUNCTIONS FOR GENERAL COMPONENT =====================&\\

  //&===================== FUNCTIONS FOR SEND AND UPDATE Template =====================&\\

  //-================== FUNCTTION OPEN OR CLOSE MODAL ADD Template ==================-\\
  public ToggleModalAddTemplate(CloseOrOpen: boolean): void {
    const ModalAddTemplate = document.getElementById('ModalAddTemplate') as HTMLElement;
    CloseOrOpen ? ModalAddTemplate.classList.add('active') : ModalAddTemplate.classList.remove('active');
  }

  //-================== FUNCTION FOR ADD CLASS HOVER INPUT FILE ==================-\\
  public Load_File(): void {
    const Drag_Drop = document.getElementById('Drag-Drop') as HTMLDivElement;
    Drag_Drop.classList.add('active');
  }

  //-================== FUNCTION FOR REMOVE CLASS HOVER INPUT FILE ==================-\\
  public Onload_File(): void {
    const Drag_Drop = document.getElementById('Drag-Drop') as HTMLDivElement;
    Drag_Drop.classList.remove('active');
  }

  //-================== FUNCTION TO CAPTURE FILE UPLOAD (Template) ==================-\\
  public Load_Document_Template(data: Event): void {
    const Target = data.target as HTMLInputElement;
    let file: File = (Target.files as FileList)[0];

    if (file) {
      this.FileAuxAddTemplate = {
        FileData: file,
        FileName: file.name
      }


      !this.IsUpdate ? this.Send_Template() : this.Send_Update_Template();

    }
    this.Onload_File();
    this.MyInputAddTemplate.nativeElement.value = null;
  }

  //-================== FUNCTION FOR SEND NEW Template ==================-\\
  private Send_Template(): void {

    const Create_Template: Create_Template_CCP = {
      Name: this.FileAuxAddTemplate.FileName,
      Extension: this.FileAuxAddTemplate.FileName.split('.').pop() || '',
      Status: 1,
      ID_Previous_Version: null,
    }

    Swal.fire({
      title: '¿Está seguro de cargar este template?',
      text: `¡El nombre del template es ${this.FileAuxAddTemplate.FileName}!`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: this.ColorConfirm,
      cancelButtonColor: this.ColorsCancel,
      confirmButtonText: 'Si, Cargar template!'
    }).then(async (result) => {

      if (result.isConfirmed) {
        this.Animation_Modal_Template(true);

        const Container_Progress_Template = document.getElementById('Container-Progress-Template') as HTMLDivElement;
        Container_Progress_Template.classList.add('active');

        setTimeout(async () => {

          try {

            const ResTemplate: Response_CCP = await firstValueFrom(this.Service_CCP.Upload_Template(Create_Template));

            if (ResTemplate.success) {
              const Template: Template_CCP = ResTemplate.operation;

              await this.Send_File_Modal(Template);

              Container_Progress_Template.classList.remove('active');
              this.Animation_Modal_Template(false);
              this.ToggleModalAddTemplate(false);
              this.Load_Component();

              Swal.fire({
                icon: 'success',
                title: 'Template cargado correctamente',
                confirmButtonColor: this.ColorConfirm
              })

            }

          } catch (e) {

            Swal.fire({
              title: 'Error en el Template',
              text: '¡No se guardo el Template en el sistema, informa a tu supervisor!',
              icon: 'warning',
              confirmButtonColor: this.ColorConfirm
            })

            Container_Progress_Template.classList.remove('active');
            this.Animation_Modal_Template(false);
            this.ToggleModalAddTemplate(false);
            this.Load_Component();
          }
        }, 2500);


      }

    })

  }

  //-================== FUNCTION FOR SEND DATA Template ==================-\\
  private Send_File_Modal(Template: Template_CCP): Promise<boolean> {

    return new Promise((resolve, reject) => {


      const TextProgress = document.getElementById('TextProgress') as HTMLDivElement;
      const Progress_Bar_Template = document.getElementById('Progress-Bar-Template') as HTMLDivElement;

      const File = new FormData();

      File.append('File_Template', this.FileAuxAddTemplate.FileData, encodeURIComponent(Template.ID + '.' + Template.Extension))

      try {

        this.Service_CCP.Upload_Template_File(File).subscribe(async (event: any) => {

          if (event.status === 500) {

            Progress_Bar_Template.style.width = "0%";
            TextProgress.innerHTML = "0%";
            Swal.fire({
              title: 'Error en el Template',
              text: '¡Ha ocurrido un error al cargar el Template, informe al supervisor!',
              icon: 'warning',
              confirmButtonColor: this.ColorConfirm
            })

          }

          if (event['loaded'] && event['total']) {
            let value = (Math.round(event['loaded'] / event['total'] * 100));
            Progress_Bar_Template.style.width = value + "%";
            TextProgress.innerHTML = value + "%";
          }

          if (event['body']) {
            Progress_Bar_Template.style.width = "0%";
            TextProgress.innerHTML = "0%";
            resolve(true);
          }

        })

      } catch (e) {
        Swal.fire({
          title: 'Error en el Template',
          text: '¡No se guardo el Template en el sistema, informa a tu supervisor!',
          icon: 'warning',
          confirmButtonColor: this.ColorConfirm
        })

        reject(false);
      }

    })

  }

  //-================== FUNCTION FOR SEND Template FILE  ==================-\\
  private Animation_Modal_Template(DiabledOrEnabled: boolean): void {
    const Pro_popup3 = document.getElementById('Pro-popup3') as HTMLDivElement;
    const Pro_inside3 = document.getElementById('Pro-inside3') as HTMLDivElement;
    const Pro_content3 = document.getElementById('Pro-content3') as HTMLDivElement;
    DiabledOrEnabled ? Pro_popup3.classList.add('active') : Pro_popup3.classList.remove('active');
    DiabledOrEnabled ? Pro_inside3.classList.add('active') : Pro_inside3.classList.remove('active');
    DiabledOrEnabled ? Pro_content3.classList.add('active') : Pro_content3.classList.remove('active');
  }

  //-================== FUNCTION FOR SEND UPDATE Template ==================-\\
  private Send_Update_Template(): void {

    const Create_Template: Create_Template_CCP = {
      Name: this.FileAuxAddTemplate.FileName,
      Extension: this.FileAuxAddTemplate.FileName.split('.').pop() || '',
      Status: 1,
      ID_Previous_Version: this.Template_Selected.ID,
    }

    Swal.fire({
      title: '¿Está seguro de actualizar este template?',
      text: `¡El nombre del template es ${this.FileAuxAddTemplate.FileName}!`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: this.ColorConfirm,
      cancelButtonColor: this.ColorsCancel,
      confirmButtonText: 'Si, actualizar template!'
    }).then(async (result) => {

      if (result.isConfirmed) {
        this.Animation_Modal_Template(true);

        const Container_Progress_Template = document.getElementById('Container-Progress-Template') as HTMLDivElement;
        Container_Progress_Template.classList.add('active');

        setTimeout(async () => {

          try {

            const ResTemplate: Response_CCP = await firstValueFrom(this.Service_CCP.Upload_Template(Create_Template));

            if (ResTemplate.success) {
              const Template: Template_CCP = ResTemplate.operation;

              await this.Send_File_Modal(Template);

              Container_Progress_Template.classList.remove('active');
              this.Animation_Modal_Template(false);
              this.ToggleModalAddTemplate(false);
              this.Load_Component();

              Swal.fire({
                icon: 'success',
                title: 'Template cargado correctamente',
                confirmButtonColor: this.ColorConfirm
              })

            }

          } catch (e) {

            Swal.fire({
              title: 'Error en el Template',
              text: '¡No se guardo el Template en el sistema, informa a tu supervisor!',
              icon: 'warning',
              confirmButtonColor: this.ColorConfirm
            })

            Container_Progress_Template.classList.remove('active');
            this.Animation_Modal_Template(false);
            this.ToggleModalAddTemplate(false);
            this.Load_Component();
          }
        }, 2500);


      }

    })

  }

  //&===================== END FUNCTIONS FOR SEND AND UPDATE Template =====================&\\


  //&===================== FUNCTIONS FOR OPTION CARD =====================&\\


  //-============== FUNCTION FOR DOWNLOAD Template ==============\\
  public async Download_Template(Template: Template_CCP): Promise<void> {

    try {

      const ResGetURLTemplate: Response_CCP = await firstValueFrom(this.Service_CCP.Get_URL_Download_Template_CCP({ ID: Template.ID }));

      if (ResGetURLTemplate.success) {

        const URL = ResGetURLTemplate.operation.URL_Template;

        const IsDownload = this.Download_File_Template(URL, Template.Name);

        if (!IsDownload) throw new Error('No file Download');
      }

    } catch (e) {

      const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener('mouseenter', Swal.stopTimer)
          toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
      })

      Toast.fire({
        icon: 'error',
        title: '¡Error al descargar la plantilla, informa a tu supervisor!'
      })
    }

  }

  private async Download_File_Template(URL: string, File_Name: string): Promise<boolean> {


    return new Promise((resolve) => {

      const ProgressModal = document.getElementById('ProgressModal') as HTMLDivElement;
      const Progress_Bar_Table = document.getElementById('Progress-Bar-Table') as HTMLElement;
      ProgressModal.classList.add('active');


      this.Service_FIN.Download_File_FIN(URL, File_Name).subscribe((Data_Download: Download_CPP) => {


        if (Data_Download.state === "IN_PROGRESS") {
          Progress_Bar_Table.style.width = Data_Download.progress + '%';
        }

        if (Data_Download.state === "DONE") {

          ProgressModal.classList.remove('active');
          Progress_Bar_Table.style.width = '0%';

          const Toast = Swal.mixin({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 1500,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener('mouseenter', Swal.stopTimer)
              toast.addEventListener('mouseleave', Swal.resumeTimer)
            }
          })

          Toast.fire({
            icon: 'success',
            title: 'Template descargado!'
          })

          resolve(true)
        }


        if (Data_Download.Status === 404 || Data_Download.Status === 500) {


          const Toast = Swal.mixin({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener('mouseenter', Swal.stopTimer)
              toast.addEventListener('mouseleave', Swal.resumeTimer)
            }
          })

          Toast.fire({
            icon: 'error',
            title: '¡Error al descargar la plantilla, informe a su supervisor!'
          })

          ProgressModal.classList.remove('active');
          Progress_Bar_Table.style.width = '0%';

          resolve(false);
        }

      })
    })

  }

  public Delete_Template(Template: Template_CCP): void {

    let NameTemplate = Template.Name.split('.');
    NameTemplate.pop();

    const Name_Clen: string = NameTemplate.join('.');

    Swal.fire({
      title: 'Eliminar Template',
      icon: 'warning',
      text: `¿Desea eliminar la plantilla ${Name_Clen}?`,
      showCancelButton: true,
      confirmButtonColor: this.ColorConfirm,
      cancelButtonColor: this.ColorsCancel,
      confirmButtonText: 'Sí, Eliminar',
      cancelButtonText: 'No, Cancelar',
    }).then((async result => {

      if (result.isConfirmed) {

        Swal.fire({
          title: 'Nuevamente ¿está seguro?',
          text: `¡Para eliminar la plantilla escriba ${Name_Clen} !`,
          input: 'text',
          confirmButtonText: 'Continuar <i class="fa-solid fa-right-long"></i>',
          confirmButtonColor: this.ColorConfirm,
          cancelButtonColor: this.ColorsCancel,
          showCancelButton: true,
        }).then((async result2 => {

          if (result2.isConfirmed) {

            const ValueInput: string = result2.value;

            if (ValueInput.toLowerCase() === Name_Clen.toLowerCase()) {

              try {

                const ResDelete: Response_CCP = await firstValueFrom(this.Service_CCP.Delete_Template_CCP({ ID: Template.ID }));

                if (ResDelete.success) {
                  Swal.fire({
                    icon: 'success',
                    title: 'Template eliminado',
                    text: '¡Se elimino correctamente la plantilla!',
                    confirmButtonColor: this.ColorConfirm
                  });
                  this.Load_Component();
                }

              } catch (e) {
                Swal.fire({
                  icon: 'warning',
                  title: 'Error al eliminar la plantilla',
                  text: '¡No se eliminó la plantilla, notifica a tu supervisor!',
                  confirmButtonColor: this.ColorConfirm
                });
                this.Load_Component();
              }

            } else {
              Swal.fire({
                icon: 'warning',
                title: 'Sin coincidencia',
                text: '¡Escriba correctamente el nombre del template para eliminarlo!',
                confirmButtonColor: this.ColorConfirm
              })
            }
          }
        }))
      }

    }))
  }

  //&===================== END FUNCTIONS FOR OPTION CARD =====================&\\
}
